'use client'
import { assertPackageVersion } from '@dynamic-labs/assert-package-version';
import { version } from '../package.js';
export { EthereumWalletConnector } from './connector/EthereumWalletConnector.js';
export { isEthWalletConnector } from './connector/isEthWalletConnector/isEthWalletConnector.js';
export { createConnector } from './connector/createConnector/createConnector.js';
import './rpc/RpcProvidersEthereum/RpcProvidersEthereum.js';
export * from '@dynamic-labs/rpc-providers';
export { evmProvidersSelector } from './rpc/evmProvidersSelector/evmProvidersSelector.js';
export { ViemRpcUiTransaction } from './utils/viem/ViemRpcUiTransaction/ViemRpcUiTransaction.js';
export { ViemUiTransaction } from './utils/viem/ViemUiTransaction/ViemUiTransaction.js';
export { chainsMap } from './utils/viem/chainsMap/chainsMap.js';
export { confirmationTransport } from './utils/viem/confirmationTransport/confirmationTransport.js';
export { createTransportWithUiConfirmation } from './utils/viem/createTransportWithUiConfirmation/createTransportWithUiConfirmation.js';
export { createViemUiTransaction } from './utils/viem/createViemUiTransaction/createViemUiTransaction.js';
export { createWalletClientWithUiConfirmation } from './utils/viem/createWalletClientWithUiConfirmation/createWalletClientWithUiConfirmation.js';
export { getChain, getOrMapViemChain, mapChain } from './utils/viem/getOrMapViemChain/getOrMapViemChain.js';
export { unFormatTransaction } from './utils/viem/unFormatTransaction/unFormatTransaction.js';
export { erc20Abi } from './utils/viem/erc20/abi.js';
export { interceptTransport } from './utils/viem/interceptTransport/interceptTransport.js';
export { findEvmNetwork } from './utils/findEvmNetwork/findEvmNetwork.js';
export { getNameservice } from './utils/getNameservice/getNameservice.js';
export { validateAddressFormat } from './utils/validateAddressFormat/validateAddressFormat.js';
export { parseAddress } from './utils/parseAddress/parseAddress.js';
export { EthereumWallet } from './wallet/EthereumWallet.js';
export { isEthereumWallet } from './wallet/isEthereumWallet/isEthereumWallet.js';

assertPackageVersion('@dynamic-labs/ethereum-core', version);
